import { render } from "./ImageContentPluginForm.vue?vue&type=template&id=4c7c98ed"
import script from "./ImageContentPluginForm.vue?vue&type=script&lang=js"
export * from "./ImageContentPluginForm.vue?vue&type=script&lang=js"

import "./ImageContentPluginForm.vue?vue&type=style&index=0&id=4c7c98ed&lang=css"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"backend/vue/imagecontentpluginform/ImageContentPluginForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c7c98ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c7c98ed', __exports__)) {
    api.reload('4c7c98ed', __exports__)
  }
  
  module.hot.accept("./ImageContentPluginForm.vue?vue&type=template&id=4c7c98ed", () => {
    api.rerender('4c7c98ed', render)
  })

}


export default __exports__